
import jobConfirm from './jobConfirm'
import rating from './rating.vue'
import OnsiteRating from './OnsiteRating.vue'
import stampStep from './stampStep.vue'
import stampFirstStep from './stampFirstStep.vue'
export default {
  jobConfirm,
  rating,
  OnsiteRating,
  stampStep,
  stampFirstStep
}



// WEBPACK FOOTER //
// ./src/components/Job/index.js